import { PlanType, ProductType } from "../constants";
import { compareVersions } from ".";

export const getMobileOperatingSystem = () => {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "windows";
    }

    if (/android/i.test(userAgent)) {
        return "android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
    }

    return "unknown";

}

export const onFinishedWebView = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("onFinished");
    }else {
        window.app.onFinished();
    }
}

export const onFinishedRiskWebView = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("onFinishedRisk");
    }else {
        window.app.onFinishedRisk();
    }
}

export const paymentInit = orderId => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage(`{"makePayment":"${orderId}"}`);
    }else {
        if(window.app)
            window.app.makePayment(orderId);
    }
}

export const paymentInitSubscription = (orderId, planType = null, appVersion) => {
    let device = getMobileOperatingSystem();
    const isUnavailable = !compareVersions(appVersion, "7.1.0")
    if(device === "ios"){
        if(window.webkit) {
            let query = `{"makePaymentSubscription":"${orderId}"}`;
            if(planType && planType === PlanType.ELITE_PLAN) {
                query = `{"makePaymentForLitePlan":"${orderId}"}`;    
            }
            window.webkit.messageHandlers.iOSNativeApp.postMessage(query);
        }
    }else {
        if(window.app) {
            if(isUnavailable) {
                if(planType && planType === PlanType.ELITE_PLAN) {
                    window.app.makePaymentForLitePlan(orderId);    
                } else {
                    window.app.makePaymentSubscription(orderId);
                }
            } else {
            if(planType && planType === PlanType.ELITE_PLAN) {
                window.app.makePaymentForLitePlan(orderId, ProductType.YEARLY_PRO_ELITE_PLAN);    
            } else {
                window.app.makePaymentSubscription(orderId, ProductType.AI_DIET_PLAN);
            }
          }
        }
    }
}

export const showPrescriptionURL = url => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("showPrescription");
    }else {
        if(window.app)
            window.app.showPrescription(url);
    }
}

export const checkMyDietPlan = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("checkMyDietPlanMob");
    }else {
        if(window.app)
            window.app.checkMyDietPlanMob();
    }
}

export const generateMyDietPlan = () => {
    // checkedResponses, checkedData, creatingDietPlan
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("generateMyDietPlanMob");
    }else {
        if(window.app)
            window.app.generateMyDietPlanMob();
    }
}

export const sendFirebaseEvent = (event, contentType, itemType) => {
    let device = getMobileOperatingSystem();
    let eventObj = {
        "event":event,
        "properties":{
          "content_type":contentType
        }
    }
    if(itemType) {
        eventObj.properties = {...eventObj.properties, ...{"item_type":itemType}}
    }
    if(device === "ios"){
        if(window.webkit){
            let gaEvent = JSON.stringify(eventObj);
            window.webkit.messageHandlers.iOSNativeApp.postMessage(gaEvent);
        }
    }else {
        if(window.app){
            let gaEvent = JSON.stringify(eventObj);
            window.app.sendFirebaseEventMob(gaEvent);
        }
    }
}

export const callUserAPIWebView = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("callUserAPI");
    }else {
        if(window.app)
            window.app.callUserAPI();
    }
}

export const openGoalSetWeb = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("openGoalSet");
    }else {
        if(window.app)
            window.app.openGoalSet();
    }
}

export const needHelpEmailWeb = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("needHelpEmail");
    }else {
        if(window.app)
            window.app.needHelpEmail();
    }
}

export const showChatWeb = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("showChat");
    }else {
        if(window.app)
            window.app.showChat();
    }
}

export const hideChatWeb = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("hideChat");
    }else {
        if(window.app)
            window.app.hideChat();
    }
}

export const getActivateHooksWeb = () => {
    let device = getMobileOperatingSystem();
    if(device === "ios"){
        if(window.webkit)
            window.webkit.messageHandlers.iOSNativeApp.postMessage("getActivateHooks");
    }else {
        if(window.app)
            window.app.getActivateHooks();
    }
}

export const TERMS_AND_CONDITIONS_URL = "https://terms.drtrust360.com/";

/**
 * Opens Terms & Conditions. In the native app WebView, `target="_blank"` is often ignored;
 * iOS/Android bridges must be used when available, with URL fallbacks for browser / older WebViews.
 */
export const openTermsAndConditionWeb = () => {
    const device = getMobileOperatingSystem();
    const url = TERMS_AND_CONDITIONS_URL;

    if (device === "ios" && window.webkit?.messageHandlers?.iOSNativeApp) {
        window.webkit.messageHandlers.iOSNativeApp.postMessage("openTermsAndCondition");
        return;
    }

    if (device === "android" && typeof window.app?.openTermsAndCondition === "function") {
        try {
            window.app.openTermsAndCondition();
            return;
        } catch (e) {
            // Fall through to URL open (e.g. bridge stub in dev)
        }
    }

    const opened = window.open(url, "_blank", "noopener,noreferrer");
    if (!opened || opened.closed || typeof opened.closed === "undefined") {
        window.location.assign(url);
    }
};


